import { VideoProvider } from '../components/atoms/Video/Video.constants';

/**
 * @param {VideoProps} props
 * @returns {string} The video source URL
 */
const getVideoSrc = ({
  videoId,
  cloudName,
  poster,
  provider,
  autoplay,
  disableControls,
  hash,
}) => {
  const isAutoplay = autoplay ? '1' : '0';
  const controls = disableControls ? '0' : '1';
  switch (provider) {
    case VideoProvider.youtube:
      return `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&autoplay=${isAutoplay}&controls=${controls}`;
    case VideoProvider.vimeo:
      return `https://player.vimeo.com/video/${videoId}?autoplay=${isAutoplay}&title=0&byline=0&portrait=0&autopause=0&muted=0&transparent=0&dnt=1&playsinline=1&controls=${controls}&h=${hash}`;
    case VideoProvider.cloudinary:
      return `https://player.cloudinary.com/embed/?cloud_name=${cloudName}&public_id=${videoId}&player%5Bfluid%5D=true&player%5BshowLogo%5D=false&player%5Bcontrols%5D=true&player%5Bskin%5D=light&player%5Bposter_options%5D%5Btransformation%5D%5Bstart_offset%5D=${poster}&source%5Bsource_types%5D%5B0%5D=mp4`;
    default:
      return '';
  }
};

export default getVideoSrc;
